import { ChatTypeEnum } from '@medentee/enums'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'services/query'
import { Button, ConfirmationModal } from 'App/components/common'
import { getChatRoomsRequest, hideModalAction, useAppDispatch } from 'store'
import { eventLeaveChannel } from 'api/events'

type TEventLeaveChannelConfirmProps = {
  eventId: string
  channelId: string
}

const EVENT_LEAVE_CHANNEL_QUERY_KEY = 'event_leave_channel'

export const EventLeaveChannelConfirm = ({
  eventId,
  channelId
}: TEventLeaveChannelConfirmProps) => {
  const dispatch = useAppDispatch()

  const { t } = useTranslation()

  const { mutate, isLoading } = useMutation({
    mutationKey: [EVENT_LEAVE_CHANNEL_QUERY_KEY],
    mutationFn: eventLeaveChannel,
    onSuccess: () => {
      dispatch(
        getChatRoomsRequest({
          eventId,
          chatType: [ChatTypeEnum.EVENT_CHANNEL, ChatTypeEnum.EVENT_NEWS]
        })
      )
      dispatch(hideModalAction())
    }
  })

  const handleClick = () => {
    mutate({
      eventId,
      channelId
    })
  }

  return (
    <ConfirmationModal
      content={t('modal.leaveChannelConfirm.content')}
      controls={
        <Button loading={isLoading} disabled={isLoading} onClick={handleClick}>
          {t('modal.leaveChannelConfirm.submitButton')}
        </Button>
      }
    />
  )
}
